module.exports = __webpack_public_path__ + "static/media/movingservice.086ceb59.png";